export {RessourceViewerComponent} from './lib/components/ressource-viewer/ressource-viewer.component';
export * from './lib/components/directives/components-register';
export {DynamicComponentDirective} from './lib/components/directives/dynamic-component.directive';
export {SurveyViewerComponent} from './lib/components/survey-viewer/survey-viewer.component';
export {TemplateComponent} from './lib/components/template/template.component';
export {SessionViewerComponent} from './lib/components/session-viewer/session-viewer.component'
export {EventViewerComponent} from './lib/components/event-viewer/event-viewer.component'